import * as Sentry from '@sentry/react'

// Whether metrics emission is active. When no DSN is configured (local dev,
// tests without a DSN), metrics are never sent, so emit calls are cheap no-ops.
const enabled = !!import.meta.env.VITE_SENTRY_DSN

type MetricAttributes = Record<string, string | number | boolean>

export function metricCount(
  name: string,
  value = 1,
  attributes?: MetricAttributes,
) {
  if (!enabled) return
  try {
    Sentry.metrics.count(name, value, attributes ? { attributes } : undefined)
  } catch {
    // Metrics must never break app functionality — ignore emit errors.
  }
}

export function metricDistribution(
  name: string,
  value: number,
  unit?: string,
  attributes?: MetricAttributes,
) {
  if (!enabled) return
  try {
    const options: Record<string, unknown> = {}
    if (unit) options.unit = unit
    if (attributes) options.attributes = attributes
    Sentry.metrics.distribution(name, value, options)
  } catch {
    // Metrics must never break app functionality — ignore emit errors.
  }
}
